import React, { useState } from 'react';
import {
  ActionButton,
  Button,
} from '@makeably/creativex-design-system';
import { recordProps } from 'components/internal/explorer/shared';
import ConfirmationModal from 'components/molecules/ConfirmationModal';
import {
  addErrorToast,
  addToast,
} from 'components/organisms/Toasts';
import { post } from 'utilities/requests';
import {
  disableInternalUserPath,
  enableInternalUserPath,
  internalUserActAsPath,
} from 'utilities/routes';
import { titleize } from 'utilities/string';

const propTypes = {
  record: recordProps.isRequired,
};

function UserActions({ record }) {
  const [confirmActive, setConfirmActive] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const userAction = record.active ? 'disable' : 'enable';

  const handleActive = async () => {
    setIsActive(true);

    const path = record.active ? disableInternalUserPath : enableInternalUserPath;
    const { isError } = await post(path(record.id));

    if (isError) {
      addErrorToast(`Could not ${userAction} user. Please try again later`);
    } else {
      addToast(`User successfully ${userAction}ed`);
      window.location.reload();
    }

    setConfirmActive(false);
    setIsActive(false);
  };

  return (
    <>
      <div className="u-flexRow u-alignCenter u-gap-8">
        <ActionButton
          active={isActive}
          disabled={!record.active}
          label="Act As"
          url={internalUserActAsPath(record.id)}
          variant="secondary"
          onClick={() => setIsActive(true)}
        />
        <Button
          label={`${titleize(userAction)} User`}
          variant={record.active ? 'destructive' : 'secondary'}
          onClick={() => setConfirmActive(true)}
        />
      </div>
      <ConfirmationModal
        actionButtonActive={isActive}
        isOpen={confirmActive}
        message={`Are you sure you want to ${userAction} ${record.first_name} ${record.last_name}?`}
        title={`Confirm User ${titleize(userAction)}`}
        onClose={() => setConfirmActive(false)}
        onConfirm={handleActive}
      />
    </>
  );
}

UserActions.propTypes = propTypes;

export default UserActions;
